<template>

  <v-layout align-center justify-center class="mt-200 pt-16">
    <v-flex>
<v-row>
  <v-col cols="12" sm="12" class="mb-4">

  <v-carousel cycle
             reverse
              vertical
              height="auto"
              hide-delimiter-background
              show-arrows-on-hover
  >
    <v-card   light>
      <v-carousel-item
          v-for="(item,i) in items"
          :key="i">
        <v-img :src="item.base64Img" max-height="500" aspect-ratio="1.77"></v-img>
      </v-carousel-item>
    </v-card>

  </v-carousel>


  </v-col>

</v-row>
<!--      <v-divider/>-->
<!--        <v-row >-->
          <v-expansion-panels    v-model="panel" multiple>
            <v-expansion-panel
                v-for="(item,i) in menuList" :key="i"
            >
              <v-expansion-panel-header>
<!--                {{item.title}}-->
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col   lg="3" md="6" v-for="(child,j) in item.menuDTOList" :key="j">

                    <v-card
                        elevation="0"
                        class="module-card"
                        :to="child.to"
                        outlined
                    >
                      <v-list-item>


                        <v-list-item-content>
                          <v-list-item-title class="text-body-2">
                            {{ child.title }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-avatar class="square-avatar" size="50">
                          <v-img
                              :src="require(`../../assets/${child.img}`)"
                              contain
                          />
                        </v-list-item-avatar>
                      </v-list-item>
                    </v-card>
                </v-col>
                </v-row>

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>


<!--        </v-row>-->
    </v-flex>
  </v-layout>

</template>

<script>
import colors from 'vuetify/lib/util/colors'
import Slider_se from "../define/slideShow/Slider_se";

export default {
  name: 'Home',
  data() {
    return {
      menuList:[],
      orange:colors.orange.darken3,
      items: [],
      panel: [0,1]
    }
  },
  methods:{
    mapItem () {
      this.menuList=this.$store.state.menuList
    },
    getImgForSlider(){
      Slider_se.getPage().then(response => {
        this.items = response.data.list
      });
    }
  },
  created() {
    this.mapItem()
    this.getImgForSlider()
  }
}
</script>
<style>
.module-card {
  height: 80px;
  border-radius: 5px;
  border: 1px solid orange;
}
.square-avatar {
  border-radius: 0 !important; /* مربع */
  width: 60px;
  height: 60px;
}


</style>


